module.exports = __webpack_public_path__ + "img/wizard-loader-5.f55dc5bc.png";